import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

// import logo from '../../assets/images/logo.png';

import UserForm from './components/UserformNew';
import CompanyForm from './components/CompanyFormNew';
import EmailValidation from './components/validationNew';
import { WorldIcon } from '../../shared/component/svgIcon';
import DropDownMenu from '../../shared/component/DropDownMenu';
import BackgroundLogin from '../LoginNew/BackgroundLogin';
import loginImage from '../../assets/images/wejha_login_logo.png';
import { getI18Next } from '../../utils/helpers';

function RegisterNew() {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLanguageCode = getI18Next();

  const [formStage, setFormStage] = useState(location?.state?.formStage || 1);
  // const [formData, setFormData] = useState();
  // const [subTitle, setSubtitle] = useState(
  //   <>{t('letGetYouToCreate')} <br /> {t('startsByCreating')}</>,
  // );
  const [formData, setFormData] = useState(() => ({
    email: location?.state?.user_email || localStorage.getItem('user_email') || '',
  }));
  const handleLanguage = (code) => {
    i18next.changeLanguage(code);
    window.location.reload();
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef(null);

  const videoData = [
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/weather.mp4',
      heading: t('wEATHER'),
      text: (
        t('weatherInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/template.mp4',
      heading: t('tEMPLATES'),
      text: (
        t('templatesInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/content.mp4',
      heading: t('cONTENTLAYOUT'),
      text: (
        t('contentLayoutInfo')
      ),
    },
  ];
  const handleVideoEnd = () => {
    setCurrentIndex((prev) => (prev + 1) % videoData.length);
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play();
    }
  }, [currentIndex]);

  const menuList = [
    {
      code: 'en',
      name: 'English',
      function: handleLanguage,
      disabled: currentLanguageCode === 'en',
    },
    {
      code: 'ar',
      name: 'عربي (Arabic)',
      function: handleLanguage,
      disabled: currentLanguageCode === 'ar',
    },
  ];
  return (
    <>
      <BackgroundLogin />
      <div className="register-container">
        <div className="banner-wrap">
          <div className="left-content">
            <img
              src={loginImage}
              alt="Logo"
              className="brand-logo"
            // style={{
            //   alignSelf: 'flex-start',
            //   display: 'block',
            //   margin: 0,
            //   padding: 0,
            // }}
            />
            <p className="caption-text">
              {t('effortlesslyCreate')}
              <span className="highlight-green"> {t('schedules')} </span>
              {t('andManage')}
              <span className="highlight-green"> {t('signage')}.</span>
            </p>
            <div className="tv-box">
              {/* You can place an image, animation, or SVG here */}
              <video
                ref={videoRef}
                src={videoData[currentIndex].src}
                autoPlay
                muted
                playsInline
                onEnded={handleVideoEnd}
                className="video-box"
              />
            </div>
            <div className="sub-tv">
              {/* sub tv */}
            </div>
            <div className="sub-title">
              <div className="heading">{videoData[currentIndex].heading}</div>
              <div className="sub-text">
                {videoData[currentIndex].text}
              </div>
            </div>
          </div>
        </div>
        <div className="register-form-wrap">
          <div className="register-form">
            {/* <img src={logo} alt="Logo" className="register-logo" />
            <div className="form-header">
              <h1>{t('createYourAccount')}</h1>
              <p>{subTitle}</p>
            </div> */}
            {formStage === 1
              && (
                <EmailValidation
                  formData={formData}
                  setFormData={setFormData}
                  setFormStage={setFormStage}
                // setSubtitle={setSubtitle}
                />
              )}
            {formStage === 2
              && (
                <UserForm
                  formData={formData}
                  setFormData={setFormData}
                  setFormStage={setFormStage}
                />
              )}
            {formStage === 3
              && (
                <CompanyForm
                  formData={formData}
                  setFormData={setFormData}
                  setFormStage={setFormStage}
                  page={location?.state?.page}
                  user_email={location?.state?.user_email}
                />
              )}

          </div>
          <div className={currentLanguageCode === 'ar'
            ? 'language-wrap-absolute-ar'
            : 'language-wrap-absolute'}
          >
            <p>{currentLanguageCode === 'en' ? 'English' : 'عربي '}</p>
            <DropDownMenu
              dropdown="dropdown"
              icon={<WorldIcon />}
              // icon={<span className="select-box-icon"><TopArrowIcon /></span>}
              action={menuList}
              tooltip={t('language')}
              from="language"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterNew;
